import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PrintOrderModal from "./PrintOrderModal";

interface Props {
  order: any;
  isRTL: boolean;
  t: (key: string, options?: any) => string;
  statusColors: Record<string, string>;
  getStatusText: (status: string) => string;
  user?: any;
  error?: string;
}

const OrderDetailsHeader: React.FC<Props> = ({
  order,
  isRTL,
  t,
  statusColors,
  getStatusText,
  user,
  error,
}) => {
  const navigate = useNavigate();
  const [showPrintModal, setShowPrintModal] = useState(false);

  return (
    <>
      <div className="mb-8">
        <div
          className={`flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6 ${
            isRTL ? "sm:flex-row-reverse" : ""
          }`}
        >
          <div className={isRTL ? "text-right" : ""}>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              {t("order.orderDetails")}
            </h1>
            <div className={`flex items-center gap-3 ${isRTL ? "flex-row-reverse" : ""}`}>
              <span className="text-gray-600">{t("order.orderId")}:</span>
              <span className="font-mono bg-gray-100 px-3 py-1 rounded-lg font-bold text-gray-800">
                #{order.id}
              </span>
              <span className={`px-3 py-1 rounded-full text-sm font-medium ${statusColors[order.status]}`}>
                {getStatusText(order.status)}
              </span>
            </div>
          </div>

          <div className={`flex gap-3 ${isRTL ? "flex-row-reverse" : ""}`}>
            <button
              onClick={() => navigate(-1)}
              className="px-5 py-2.5 bg-white border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 transition-colors duration-200 font-medium flex items-center gap-2"
              aria-label={t("common.goBack")}
            >
              ← {t("common.back")}
            </button>

            {user && ["branch_owner", "super_admin"].includes(user.role) && (
              <button
                onClick={() => setShowPrintModal(true)}
                className="px-5 py-2.5 bg-blue-500 text-white rounded-xl hover:bg-blue-600 transition-colors duration-200 font-medium flex items-center gap-2"
                aria-label={t("order.print")}
              >
                🖨️ {t("print.printOrder")}
              </button>
            )}
          </div>
        </div>

        {error && (
          <div className="mb-6 bg-red-50 border border-red-200 text-red-600 p-4 rounded-xl">
            {error}
          </div>
        )}
      </div>

      {/* Print Modal */}
      <PrintOrderModal
        order={order}
        isOpen={showPrintModal}
        onClose={() => setShowPrintModal(false)}
      />
    </>
  );
};

export default OrderDetailsHeader;